import * as React from "react";
import styled, { css } from "styled-components";
import { useMappedState } from "redux-react-hook";
import _ from "lodash";
import { toast } from "react-toastify";

import { Text } from "src/library/components/Text";
import { Select } from "src/library/components/Forms";
import { IStore } from "src/core/shared/store";

import { IOrderVariant } from "../api/orders.api";

interface IProps {
  orderVariant: IOrderVariant | undefined;
  handleUpdate: React.Dispatch<React.SetStateAction<number | null>>;
  availableOrderVariants?: IOrderVariant[]
}

/**
 * Selector for choosing an order variant.
 * Consumer responsible for managing selected variant.
 */
export const SelectOrderVariant: React.ReactFCWithChildren<IProps> = ({
  orderVariant, handleUpdate, availableOrderVariants
}) => {
  const { accessibleOrderVariants } = useMappedState(({ users }: IStore) => ({ accessibleOrderVariants: users.accessibleOrderVariants || [] }));
  const orderVariantsToUse = availableOrderVariants ?? accessibleOrderVariants;

  return (
    <StyledWrapper>
      <Select
        as="select"
        name="select-order-variant"
        autoHideLabels
        label="Select Order Variant"
        value={orderVariant?.id.toString() ?? ""}
        options={orderVariantsToUse.map(ov => ({
          text: ov.name,
          value: ov.id.toString()
        }))}
        handleChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          const selectedVariant = _.find(orderVariantsToUse, ov => ov.id === parseInt(event.target.value));

          if (!selectedVariant) {
            return toast.error("Unable to match against an available order variant");
          }

          return handleUpdate(selectedVariant.id);
        }}
      />

      <div className="description">
        <Text as="h4">
          Description of selection:
        </Text>

        <Text>
          {orderVariant?.description}
        </Text>
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    padding: ${theme.spacing.padding.md};
    flex-direction: column;
    padding-top: 0;
    > * {
      margin-top: ${theme.spacing.padding.sm};
    }

    .description {
      margin-top: ${theme.spacing.padding.md};
    }
  `}
`;

export default SelectOrderVariant;
